import React from 'react';
import DashboardCard from '../../DashboardComponents/DashboardCard';

/**
 * HoursCard — KPI-style hours widget.
 * `layout="inline"` matches Current Figma (icon left, value right).
 */
const HoursCard = ({
  title,
  icon,
  value,
  tone = 'neutral',
  fullHeight = false,
  layout = 'stack',
}) => (
  <DashboardCard
    title={title}
    tone={tone}
    fullHeight={fullHeight}
    className={`project-overview__hours-card ${
      layout === 'inline' ? 'project-overview__hours-card--inline' : ''
    }`}
  >
    <div
      className={`project-overview__hours-body ${
        layout === 'inline' ? 'project-overview__hours-body--inline' : ''
      }`}
    >
      <img src={icon} alt="" className="project-overview__hours-icon" width={24} height={24} />
      <p className="project-overview__hours-value">{value}</p>
    </div>
  </DashboardCard>
);

export default HoursCard;
